/* eslint-disable import/no-cycle */
/* SETTINGS */
export const CHANGE_LOCALE = 'CHANGE_LOCALE';

/* MENU */
export const MENU_SET_CLASSNAMES = 'MENU_SET_CLASSNAMES';
export const MENU_CONTAINER_ADD_CLASSNAME = 'MENU_CONTAINER_ADD_CLASSNAME';
export const MENU_CLICK_MOBILE_MENU = 'MENU_CLICK_MOBILE_MENU';
export const MENU_CHANGE_DEFAULT_CLASSES = 'MENU_CHANGE_DEFAULT_CLASSES';
export const MENU_CHANGE_HAS_SUB_ITEM_STATUS =
  'MENU_CHANGE_HAS_SUB_ITEM_STATUS';
export const MENU_ENABLE_SMART_HOME = 'MENU_ENABLE_SMART_HOME';
export const MENU_ENABLE_DASHBOARD = 'MENU_ENABLE_DASHBOARD';
export const LOAD_MENU = "LOAD_MENU";
export const MENU_LOADED = "MENU_LOADED";
export const MENU_ERROR = "MENU_ERROR";
export * from './menu/actions';
export * from './settings/actions';
export const ADMIN_CHANGE_DASHBOARD_TAB = "ADMIN_CHANGE_DASHBOARD_TAB";
export * from './dashboard/actions';
export const RESERVATION_CHANGE_TAB = "RESERVATION_CHANGE_TAB";
export * from './reservations/actions';
